import React from 'react';
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {accessConstants, authUtils} from "mindsets-js-sdk";

const Edit = function ({user}) {
    const me = useSelector(state => state.me);

    if (authUtils.iCan(me, [accessConstants.PERMISSION_CAN_MANAGE_USERS])) {
        return (
            <Link to={'/users/' + user.id} className="button">Edit</Link>
        );
    }

    return null;
}

Edit.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number.isRequired
    }).isRequired
};

export default Edit;
